export default [
	{
		path: "/configuracoes",
		name: "Configuracoes",
		component: () => import("../views/Index"),
		meta: { isAuthenticated: true }
	},
];
  